import { render, staticRenderFns } from "./xxhj.vue?vue&type=template&id=06243458&scoped=true&"
import script from "./xxhj.vue?vue&type=script&lang=js&"
export * from "./xxhj.vue?vue&type=script&lang=js&"
import style0 from "./xxhj.vue?vue&type=style&index=0&id=06243458&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06243458",
  null
  
)

export default component.exports